import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import SectionItem from '../../../Layout/SectionItem/SectionItem'
import './Recurring.scss'
import { LuxRadioInput, LuxSelect, LuxDatePicker, Color } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'
import SectionContainer from '@/app/components/Layout/SectionContainer/SectionContainer'
import { FormBase, SchedulingForm } from '@/app/models/new-activity-form'
import { dateFormat } from '@/root.component'

const recurrenceOptions = [
    { value: 'daily', label: 'daily' },
    { value: 'weekly', label: 'weekly' },
    { value: 'monthly', label: 'monthly' },
    { value: 'annual', label: 'annual' },
]
const everySelectOptions = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
]

const week = [
    { value: 2, label: 'tuesday' },
    { value: 3, label: 'wednesday' },
    { value: 4, label: 'thursday' },
    { value: 5, label: 'friday' },
    { value: 6, label: 'saturday' },
    { value: 0, label: 'sunday' },
]

const Recurring = (props: FormBase<SchedulingForm>) => {
    const componentClass = 'smart-new-activity-scheduling-recurring'
    const intl = useIntl()
    const { form, onSetForm } = props
    const [isPickerStartVisible, setIsPickerStartVisible] = useState(false)
    const [isPickerEndVisible, setIsPickerEndVisible] = useState(false)

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            const pickerStart = document.getElementsByClassName('recurring-start-picker')[0]
            const pickerEnd = document.getElementsByClassName('recurring-end-picker')[0]
            if (!!pickerStart && !pickerStart.contains(event.target)) {
                setIsPickerStartVisible(false)
            }
            if (!!pickerEnd && !pickerEnd.contains(event.target)) {
                setIsPickerEndVisible(false)
            }
        }
        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    const onFocus = () => {
        setIsPickerStartVisible(true)
    }
    const onFocusEnd = () => {
        setIsPickerEndVisible(true)
    }
    const onVisibleChange = (e) => {}

    const onStartChangeCallback = (value) => {
        onSetForm({ ...form, recurringStartDate: { ...form.recurringStartDate, value } })
        setIsPickerStartVisible(false)
    }
    const onEndChangeCallback = (value) => {
        onSetForm({ ...form, recurringEndDate: { ...form.recurringEndDate, value } })
        setIsPickerEndVisible(false)
    }

    return (
        <div className={componentClass}>
            <SectionContainer>
                <SectionItem>
                    <div className={`${componentClass}__radio-wrapper`}>
                        <LuxRadioInput
                            title={intl.formatMessage({
                                id: `modals.new.activity.section.scheduling.recurring.type.title`,
                                defaultMessage: 'Set recurrences',
                            })}
                            onChangeCallback={(value) =>
                                onSetForm({ ...form, recurringType: { value } })
                            }
                            value={form.recurringType.value}
                            radioList={recurrenceOptions.map((opt) => ({
                                value: opt.value,
                                label: intl.formatMessage({
                                    id: `modals.new.activity.section.scheduling.recurring.type.${opt.label}`,
                                    defaultMessage: 'option',
                                }),
                            }))}
                            name="recurrenceType"
                        />
                        {!!form.recurringType.value && (
                            <div className={`${componentClass}__radio-content`}>
                                <div className="text">
                                    {intl.formatMessage({
                                        id: `modals.new.activity.section.scheduling.recurring.every`,
                                        defaultMessage: 'Every',
                                    })}
                                </div>
                                <div className={`${componentClass}__radio-content__select`}>
                                    <LuxSelect
                                        options={everySelectOptions}
                                        value={form.recurringEvery.value}
                                        onChangeCallback={(value) =>
                                            onSetForm({ ...form, recurringEvery: { value } })
                                        }
                                        additionalProps={{
                                            appendTo: 'self',
                                        }}
                                    />
                                </div>
                                <div className="text">
                                    {intl.formatMessage({
                                        id: `modals.new.activity.section.scheduling.recurring.every.${form.recurringType.value}`,
                                        defaultMessage: '',
                                    })}
                                </div>
                            </div>
                        )}
                        {form.recurringType.value === recurrenceOptions[1].value && (
                            <div className={`${componentClass}__radio-on-content`}>
                                <LuxRadioInput
                                    title={intl.formatMessage({
                                        id: `modals.new.activity.section.scheduling.recurring.on`,
                                        defaultMessage: 'On',
                                    })}
                                    onChangeCallback={(value) =>
                                        onSetForm({ ...form, recurringOn: { value } })
                                    }
                                    value={form.recurringOn.value}
                                    radioList={[
                                        {
                                            value: '1',
                                            label: intl.formatMessage({
                                                id: 'modals.new.activity.section.scheduling.recurring.on.monday',
                                                defaultMessage: 'Monday',
                                            }),
                                        },
                                    ]}
                                    name="recurrenceOn"
                                />
                                {week.map((day) => (
                                    <LuxRadioInput
                                        key={day.value}
                                        onChangeCallback={(value) =>
                                            onSetForm({ ...form, recurringOn: { value } })
                                        }
                                        value={form.recurringOn.value}
                                        radioList={[
                                            {
                                                value: day.value?.toString(),
                                                label: intl.formatMessage({
                                                    id: `modals.new.activity.section.scheduling.recurring.on.${day.label}`,
                                                    defaultMessage: day.label,
                                                }),
                                            },
                                        ]}
                                        name="recurrenceOn"
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </SectionItem>
                <SectionItem>
                    <div className={`${componentClass}__radio-content__picker`}>
                        <LuxDatePicker
                            intl={intl}
                            locale={props.language?.split('-')[0] || 'en'}
                            additionalProps={{
                                panelClassName: 'smart-wardrobe-datepicker recurring-start-picker',
                            }}
                            value={form.recurringStartDate.value}
                            onChangeCallback={onStartChangeCallback}
                            minDate={new Date()}
                            label={intl.formatMessage({
                                id: 'modals.new.activity.section.scheduling.recurring.from',
                                defaultMessage: 'Recur from',
                            })}
                            placeholder={intl.formatMessage({
                                id: 'modals.new.activity.section.scheduling.recurring.from.start.placeholder',
                                defaultMessage: 'Select start date',
                            })}
                            showCustom
                            visible={isPickerStartVisible}
                            onFocus={onFocus}
                            onVisibleChange={onVisibleChange}
                            style={{ backgroundColor: Color.WHITE }}
                            mandatory
                        />
                    </div>
                </SectionItem>
                <SectionItem>
                    <div className={`${componentClass}__radio-until-content`}>
                        <LuxRadioInput
                            onChangeCallback={(value) =>
                                onSetForm({ ...form, recurringUntil: { value } })
                            }
                            value={form.recurringUntil.value}
                            radioList={[
                                {
                                    value: 'until',
                                    label: intl.formatMessage({
                                        id: `modals.new.activity.section.scheduling.recurring.until.date`,
                                        defaultMessage: 'Until',
                                    }),
                                },
                            ]}
                            name="recurrenceUntil"
                        />
                        <div className={`${componentClass}__radio-content`}>
                            <div className={`${componentClass}__radio-content__picker`}>
                                <LuxDatePicker
                                    intl={intl}
                                    locale={props.language?.split('-')[0] || 'en'}
                                    additionalProps={{
                                        panelClassName:
                                            'smart-wardrobe-datepicker recurring-end-picker',
                                    }}
                                    value={form.recurringEndDate.value}
                                    onChangeCallback={onEndChangeCallback}
                                    minDate={form.recurringStartDate.value}
                                    placeholder={intl.formatMessage({
                                        id: 'modals.new.activity.section.scheduling.recurring.from.end.placeholder',
                                        defaultMessage: 'Select end date',
                                    })}
                                    showCustom
                                    visible={isPickerEndVisible}
                                    onFocus={onFocusEnd}
                                    onVisibleChange={onVisibleChange}
                                    style={{ backgroundColor: Color.WHITE }}
                                />
                            </div>
                        </div>
                        <LuxRadioInput
                            onChangeCallback={(value) =>
                                onSetForm({ ...form, recurringUntil: { value } })
                            }
                            value={form.recurringUntil.value}
                            radioList={[
                                {
                                    value: 'after',
                                    label: intl.formatMessage({
                                        id: `modals.new.activity.section.scheduling.recurring.until.after.occurency`,
                                        defaultMessage: 'End after',
                                    }),
                                },
                            ]}
                            name="recurrenceUntil"
                        />
                        <div className={`${componentClass}__radio-content`}>
                            <div className={`${componentClass}__radio-content__select`}>
                                <LuxSelect
                                    options={everySelectOptions}
                                    value={form.recurringOccurrency.value}
                                    onChangeCallback={(value) =>
                                        onSetForm({ ...form, recurringOccurrency: { value } })
                                    }
                                    additionalProps={{
                                        appendTo: 'self',
                                    }}
                                />
                            </div>
                            <div className="text">
                                {intl.formatMessage({
                                    id: `modals.new.activity.section.scheduling.recurring.every.select`,
                                    defaultMessage: '',
                                })}
                            </div>
                        </div>
                        <LuxRadioInput
                            onChangeCallback={(value) =>
                                onSetForm({ ...form, recurringUntil: { value } })
                            }
                            value={form.recurringUntil.value}
                            radioList={[
                                {
                                    value: 'endless',
                                    label: intl.formatMessage({
                                        id: `modals.new.activity.section.scheduling.recurring.until.no.deadline`,
                                        defaultMessage: 'No deadline',
                                    }),
                                },
                            ]}
                            name="recurrenceUntil"
                        />

                        {form.recurringType.value === recurrenceOptions[1].value && (
                            <div className={`${componentClass}__radio-on-content`}>
                                <LuxRadioInput
                                    title={intl.formatMessage({
                                        id: `modals.new.activity.section.scheduling.recurring.on`,
                                        defaultMessage: 'On',
                                    })}
                                    onChangeCallback={(value) =>
                                        onSetForm({ ...form, recurringOn: { value } })
                                    }
                                    value={form.recurringOn.value}
                                    radioList={[
                                        {
                                            value: '1',
                                            label: intl.formatMessage({
                                                id: 'modals.new.activity.section.scheduling.recurring.on.monday',
                                                defaultMessage: 'Monday',
                                            }),
                                        },
                                    ]}
                                    name="recurrenceOn"
                                />
                                {week.map((day) => (
                                    <LuxRadioInput
                                        key={day.value}
                                        onChangeCallback={(value) =>
                                            onSetForm({ ...form, recurringOn: { value } })
                                        }
                                        value={form.recurringOn.value}
                                        radioList={[
                                            {
                                                value: day.value.toString(),
                                                label: intl.formatMessage({
                                                    id: `modals.new.activity.section.scheduling.recurring.on.${day.label}`,
                                                    defaultMessage: day.label,
                                                }),
                                            },
                                        ]}
                                        name="recurrenceOn"
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </SectionItem>
            </SectionContainer>
        </div>
    )
}

const mapStateToProps = (state: any) => ({ language: state.userReducer.user.language })

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Recurring)
